import IntervalsBlock from './IntervalsBlock';

export default IntervalsBlock;
